import React from 'react';
import Select from 'react-select';

const HighwayContainerViewing = ({ handleCityChange, city, customStyles,
      handleClickSummit, loadingSummit,selectCityIsСhange}) => {
        
  return (
    <div className='equipmentDiv' style={{ marginTop: "10px" }}>
      <label className='textTitleDrawer' style={{ fontSize: "16px",textShadow: '2px 2px 4px #242424' }}>Слой "Ранг 1/2"</label>
      <hr className="horizontalLineDrawer" style={{ marginTop: "5px" }} />
      <Select
        className="selectSearchDrawer"
        value={selectCityIsСhange || ""}
        onChange={handleCityChange}
        options={[
          { value: "Вся страна", label: "Вся страна" },
          ...city.map(option => ({ value: option, label: option }))
        ]}
        isSearchable={true}
        styles={customStyles}
        placeholder="Город"
      />
      <button className='buttonAutoTopology' onClick={handleClickSummit} >Отобразить</button>
      {loadingSummit && <img src="loading.gif" alt="Загрузка..." width="30" height="30" />}
    </div>
  );
}

export default HighwayContainerViewing;